import { usd } from "./util";

const chip = (c) => {
  const venc = (c.vencimientos || []).filter((v) => v.estado === "vencido");
  if (venc.length && c.saldo && c.vencido / c.saldo < 0.01) {
    const dias = Math.max(...venc.map((v) => v.dias || 0));
    return `Atraso menor · ${dias} días · ${usd(c.vencido)}`;
  }
  return c.estado?.texto;
};

export const TarjetaCliente = ({ c, onClick, detalle }) => (
  <button type="button" className={`rs-tarjeta ${c.estado?.estado || "al_dia"} ${detalle ? "rg-brillo" : ""}`} onClick={onClick} data-testid="resumen-tarjeta" aria-label={`Tarjeta de ${c.cliente}`}>
    <div className="rs-tarjeta-top">
      <span className="rs-pill" data-testid="resumen-tarjeta-estado">{chip(c)}</span>
      {c.no_computa && <span className="rs-pill" data-testid="resumen-no-computa" style={{ background: "#4A3628", color: "#F3F7F2" }}>No computa</span>}
      <span className="rs-logo">T</span>
    </div>
    <div className="relative text-left">
      <div className="rs-nombre" data-testid="resumen-tarjeta-nombre">{c.cliente}</div>
      <div className="rs-vz">{c.vendedor} · {c.zona || "—"}</div>
    </div>
    <div className="rs-saldo relative text-left"><small>Saldo</small><b data-testid="resumen-tarjeta-saldo">{usd(c.saldo)}</b>
      {detalle && <div className="rg-sub-saldo" data-testid="resumen-tarjeta-sub">{c.facturas_n || 0} factura{c.facturas_n === 1 ? "" : "s"} · {c.pagares?.cantidad || 0} pagaré{c.pagares?.cantidad === 1 ? "" : "s"} sin firma</div>}
    </div>
  </button>
);
